/* eslint-disable no-unused-vars */
import React from "react";
import Title from "../layouts/Title";
import { one, two, three, four, five, six } from "../../assets/index";
import ProjectsCard from "./ProjectsCard";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import { FaAngleDown, FaGlobe } from "react-icons/fa";
import { BsGithub } from "react-icons/bs";

const Projects = () => {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title title="Check these out on my github" des="My Projects" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-10">
        {/* Project-one */}
        <div
          className="w-full p-4 h-auto rounded-lg shadow-shadowOne flex flex-col bg-gradient-to-r from-bodyColor to-[#202327] group hover:bg-gradient-to-b hover:from-gray-900 hover:gray-900 transition-colors duration-1000"
          data-aos="zoom-in-right"
        >
          <div class="relative max-w-full h-72 overflow-hidden">
            <div class="h-max w-full transition-transform duration-[5000ms] ease-linear transform translate-y-0 hover:-translate-y-[calc(100%-18rem)]">
              <img
                src={one}
                alt="projectOneImg"
                class="w-full object-cover object-top "
              />
            </div>
          </div>

          <div className="w-full mt-5 flex flex-col  gap-6">
            <div>
              <div className="">
                <h2 className="text-designColor font-normal text-base text-center mb-1">
                  <span className="text-white uppercase text-2xl">EcoSync</span>
                </h2>

                <Accordion
                  expanded={expanded === "panel1"}
                  onChange={handleChange("panel1")}
                >
                  <AccordionSummary
                    expandIcon={
                      <FaAngleDown className="text-gray-100 text-2xl" />
                    }
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                    style={{
                      background: "rgb(33 36 40)",
                      color: "rgb(243 244 246)",
                    }}
                  >
                    <Typography>
                      <h2 className="text-xl">
                        <b>Project Details :</b>
                      </h2>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="bg-bodyColor text-gray-100">
                    <Typography>
                      <div>
                        <h3 className="text-lg">
                          <b>Description :</b>
                        </h3>
                        <p className="text-sm mb-3 ">
                          EcoSync is a web application designed to improve waste management in Dhaka North City Corporation by optimizing waste collection and transportation. It offers real-time monitoring and data-driven tools to enhance efficiency and accountability for all stakeholders involved.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-lg">
                          <b>Features :</b>
                        </h3>
                        <ul>
                          <li>1. Three types of admin authorization</li>
                          <li>2. Real time tracking vehicle (without any tracker)</li>
                          <li>3. Leaflet map with shortest path.</li>
                          <li>4. Generate vehicle cost billing system.</li>
                        </ul>
                      </div>

                      <div className="py-2">
                        <h3 className="text-lg">
                          <b>Technology :</b>
                        </h3>
                        <p>
                          React | Node | Express | Mongodb | Leaflet | Tailwind | JWT
                        </p>
                      </div>

                      <div className="py-2">
                        <h3 className="text-lg">
                          <b>Authentication :</b>
                        </h3>
                        <p>
                          System Admin: <span className="italic text-orange-300">admin@gmail.com</span> <br />
                          Sts Manager: <span className="italic text-orange-300">srijon@gmail.com</span> <br />
                          Landfill Manager: <span className="italic text-orange-300">shakil@gmail.com</span> <br />
                        </p>
                        <p>
                          Password: <span className="italic text-orange-300">123456</span>
                        </p>
                      </div>

                      <div className="flex gap-10 justify-center items-center text-center">
                        <div className="text-center">
                          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                            <a
                              href="https://eco-sync.netlify.app"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <FaGlobe />
                            </a>
                          </span>
                          <p>Live Website</p>
                        </div>
                        <div className="text-center">
                          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                            <a
                              href="https://github.com/ashik190141/cs24-p2-JUST_POWER_RANGERS"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <BsGithub />
                            </a>
                          </span>
                          <p>GitHub Code</p>
                        </div>

                        {/* <div className="text-center">
                          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                            <a
                              href="https://github.com/airinrahat/hostel-manegement-server-side"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <BsGithub />
                            </a>
                          </span>
                          <p>Server side</p>
                        </div> */}

                      </div>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
        {/* Project-two */}
        <div
          className="w-full p-4 h-auto rounded-lg shadow-shadowOne flex flex-col bg-gradient-to-r from-bodyColor to-[#202327] group hover:bg-gradient-to-b hover:from-gray-900 hover:gray-900 transition-colors duration-1000"
          data-aos="zoom-in-right"
        >
          <div class="relative max-w-full h-72 overflow-hidden">
            <div class="h-max w-full transition-transform duration-[5000ms] ease-linear transform translate-y-0 hover:-translate-y-[calc(100%-18rem)]">
              <img
                src={two}
                alt="project-two"
                class="w-full object-cover object-top "
              />
            </div>
          </div>

          <div className="w-full mt-5 flex flex-col  gap-6">
            <div>
              <div className="">
                <h2 className="text-designColor font-normal text-base text-center mb-1">
                  <span className="text-white uppercase text-2xl">Milon Mela Matrimony</span>
                </h2>

                <Accordion
                  expanded={expanded === "panel2"}
                  onChange={handleChange("panel2")}
                >
                  <AccordionSummary
                    expandIcon={
                      <FaAngleDown className="text-gray-100 text-2xl" />
                    }
                    aria-controls="panel2bh-content"
                    id="panel2bh-header"
                    style={{
                      background: "rgb(33 36 40)",
                      color: "rgb(243 244 246)",
                    }}
                  >
                    <Typography>
                      <h2 className="text-xl">
                        <b>Project Details :</b>
                      </h2>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="bg-bodyColor text-gray-100">
                    <Typography>
                      <div>
                        <h3 className="text-lg">
                          <b>Description :</b>
                        </h3>
                        <p className="text-sm mb-3 ">
                        Milon Mela Matrimony is a matchmaking platform where users can create biodata and search for potential spouses. Users can access contact details by making a secure payment through the Stripe payment gateway, making the process of finding a partner simple and reliable.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-lg">
                          <b>Features :</b>
                        </h3>
                        <ul>
                          <li>1. Admin Authorization with firebase Authentication</li>
                          <li>2. Spouse review system</li>
                          <li>3. Stripe Payment Gateway.</li>
                        </ul>
                      </div>

                      <div className="py-2">
                        <h3 className="text-lg">
                          <b>Technology :</b>
                        </h3>
                        <p>
                          React | Node | Express | Mongodb | Firebase | Tailwind | JWT
                        </p>
                      </div>

                      <div className="py-2">
                        <h3 className="text-lg">
                          <b>Authentication :</b>
                        </h3>
                        <p>
                          System Admin: <span className="italic text-orange-300">testadmin@gmail.com</span> <br />
                        </p>
                        <p>
                          Password: <span className="italic text-orange-300">S@123456a</span>
                        </p>
                      </div>

                      <div className="flex gap-10 justify-center items-center text-center">
                        <div className="text-center">
                          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                            <a
                              href="https://milon-mela-matrimony.netlify.app"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <FaGlobe />
                            </a>
                          </span>
                          <p>Live Website</p>
                        </div>
                        <div className="text-center">
                          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                            <a
                              href="https://github.com/Its-Shojib/Milon-Mela-Matrimony-ClientSide-ReactAndFirebase"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <BsGithub />
                            </a>
                          </span>
                          <p>Client Code</p>
                        </div>

                        <div className="text-center">
                          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                            <a
                              href="https://github.com/Its-Shojib/Milon-Mela-Matrimony-ServerSide-NodeAndMongoDB"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <BsGithub />
                            </a>
                          </span>
                          <p>Server Code</p>
                        </div>

                      </div>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
        {/* Project-three */}
        <div
          className="w-full p-4 h-auto rounded-lg shadow-shadowOne flex flex-col bg-gradient-to-r from-bodyColor to-[#202327] group hover:bg-gradient-to-b hover:from-gray-900 hover:gray-900 transition-colors duration-1000"
          data-aos="zoom-in-right"
        >
          <div class="relative max-w-full h-72 overflow-hidden">
            <div class="h-max w-full transition-transform duration-[5000ms] ease-linear transform translate-y-0 hover:-translate-y-[calc(100%-18rem)]">
              <img
                src={five}
                alt="project-three"
                class="w-full object-cover object-top "
              />
            </div>
          </div>

          <div className="w-full mt-5 flex flex-col  gap-6">
            <div>
              <div className="">
                <h2 className="text-designColor font-normal text-base text-center mb-1">
                  <span className="text-white uppercase text-2xl">Meal Miracle</span>
                </h2>

                <Accordion
                  expanded={expanded === "panel3"}
                  onChange={handleChange("panel3")}
                >
                  <AccordionSummary
                    expandIcon={
                      <FaAngleDown className="text-gray-100 text-2xl" />
                    }
                    aria-controls="panel3bh-content"
                    id="panel5bh-header"
                    style={{
                      background: "rgb(33 36 40)",
                      color: "rgb(243 244 246)",
                    }}
                  >
                    <Typography>
                      <h2 className="text-xl">
                        <b>Project Details :</b>
                      </h2>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="bg-bodyColor text-gray-100">
                    <Typography>
                      <div>
                        <h3 className="text-lg">
                          <b>Description :</b>
                        </h3>
                        <p className="text-sm mb-3 ">
                        Meal Miracle is a platform that allows users to donate their extra food to those in need. Users can easily list surplus food items and manage donations, while others can request meals, fostering a community of sharing and reducing food waste.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-lg">
                          <b>Features :</b>
                        </h3>
                        <ul>
                          <li>1. Request extra food from doner</li>
                          <li>2. Authentication and Authorization</li>
                          <li>3. Donate and Add extra food by donor</li>
                        </ul>
                      </div>

                      <div className="py-2">
                        <h3 className="text-lg">
                          <b>Technology :</b>
                        </h3>
                        <p>
                          React | Node | Express | MongoDB | Tailwind | JWT | Firebase
                        </p>
                      </div>

                      <div className="flex gap-10 justify-center items-center text-center">
                        <div className="text-center">
                          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                            <a
                              href="https://food-sharing-system.web.app"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <FaGlobe />
                            </a>
                          </span>
                          <p>Live Website</p>
                        </div>
                        <div className="text-center">
                          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                            <a
                              href="https://github.com/Its-Shojib/Food-Sharing--Meal-Miracle--ClientSide-ReactAndFirebase"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <BsGithub />
                            </a>
                          </span>
                          <p>Client Code</p>
                        </div>

                        <div className="text-center">
                          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                            <a
                              href="https://github.com/Its-Shojib/Food-Sharing--Meal-Miracle--ServerSide-NodeJsAndMongoDB"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <BsGithub />
                            </a>
                          </span>
                          <p>Server Code</p>
                        </div>

                      </div>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
        {/* Project-four */}
        <div
          className="w-full p-4 h-auto rounded-lg shadow-shadowOne flex flex-col bg-gradient-to-r from-bodyColor to-[#202327] group hover:bg-gradient-to-b hover:from-gray-900 hover:gray-900 transition-colors duration-1000"
          data-aos="zoom-in-right"
        >
          <div class="relative max-w-full h-72 overflow-hidden">
            <div class="h-max w-full transition-transform duration-[5000ms] ease-linear transform translate-y-0 hover:-translate-y-[calc(100%-18rem)]">
              <img
                src={six}
                alt="project-six"
                class="w-full object-cover object-top "
              />
            </div>
          </div>

          <div className="w-full mt-5 flex flex-col  gap-6">
            <div>
              <div className="">
                <h2 className="text-designColor font-normal text-base text-center mb-1">
                  <span className="text-white uppercase text-2xl">House Hunter</span>
                </h2>

                <Accordion
                  expanded={expanded === "panel4"}
                  onChange={handleChange("panel4")}
                >
                  <AccordionSummary
                    expandIcon={
                      <FaAngleDown className="text-gray-100 text-2xl" />
                    }
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                    style={{
                      background: "rgb(33 36 40)",
                      color: "rgb(243 244 246)",
                    }}
                  >
                    <Typography>
                      <h2 className="text-xl">
                        <b>Project Details :</b>
                      </h2>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="bg-bodyColor text-gray-100">
                    <Typography>
                      <div>
                        <h3 className="text-lg">
                          <b>Description :</b>
                        </h3>
                        <p className="text-sm mb-3 ">
                        House Hunter is a platform that connects users with homeowners, allowing them to search, find, and book houses easily. With advanced search options, users can filter listings based on location, price, and other criteria to find their ideal home.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-lg">
                          <b>Features :</b>
                        </h3>
                        <ul>
                          <li>1. Book house from owner</li>
                          <li>2. Add to favorite house</li>
                          <li>3. Search house by house info.</li>
                        </ul>
                      </div>

                      <div className="py-2">
                        <h3 className="text-lg">
                          <b>Technology :</b>
                        </h3>
                        <p>
                          React | Node | Express | MongoDB | Tailwind | JWT | Swiper.js
                        </p>
                      </div>

                      <div className="flex gap-10 justify-center items-center text-center">
                        <div className="text-center">
                          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                            <a
                              href="https://bd-house-hunter.netlify.app"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <FaGlobe />
                            </a>
                          </span>
                          <p>Live Website</p>
                        </div>
                        <div className="text-center">
                          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                            <a
                              href="https://github.com/Its-Shojib/House-Hunter-ClientSIde"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <BsGithub />
                            </a>
                          </span>
                          <p>Client Code</p>
                        </div>

                        <div className="text-center">
                          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                            <a
                              href="https://github.com/Its-Shojib/House-Hunter-ServerSIde"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <BsGithub />
                            </a>
                          </span>
                          <p>Server Code</p>
                        </div>

                      </div>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
        {/* Project-five */}
        <div
          className="w-full p-4 h-auto rounded-lg shadow-shadowOne flex flex-col bg-gradient-to-r from-bodyColor to-[#202327] group hover:bg-gradient-to-b hover:from-gray-900 hover:gray-900 transition-colors duration-1000"
          data-aos="zoom-in-right"
        >
          <div class="relative max-w-full h-72 overflow-hidden">
            <div class="h-max w-full transition-transform duration-[5000ms] ease-linear transform translate-y-0 hover:-translate-y-[calc(100%-18rem)]">
              <img
                src={three}
                alt="project-five"
                class="w-full object-cover object-top "
              />
            </div>
          </div>

          <div className="w-full mt-5 flex flex-col  gap-6">
            <div>
              <div className="">
                <h2 className="text-designColor font-normal text-base text-center mb-1">
                  <span className="text-white uppercase text-2xl">Real Chat App</span>
                </h2>

                <Accordion
                  expanded={expanded === "panel5"}
                  onChange={handleChange("panel5")}
                >
                  <AccordionSummary
                    expandIcon={
                      <FaAngleDown className="text-gray-100 text-2xl" />
                    }
                    aria-controls="panel5bh-content"
                    id="panel5bh-header"
                    style={{
                      background: "rgb(33 36 40)",
                      color: "rgb(243 244 246)",
                    }}
                  >
                    <Typography>
                      <h2 className="text-xl">
                        <b>Project Details :</b>
                      </h2>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="bg-bodyColor text-gray-100">
                    <Typography>
                      <div>
                        <h3 className="text-lg">
                          <b>Description :</b>
                        </h3>
                        <p className="text-sm mb-3 ">
                        Real Chat App is a dynamic messaging platform that enables real-time chat with instant notifications. Designed for seamless communication, it ensures users stay connected with friends and colleagues through fast and reliable messaging.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-lg">
                          <b>Features :</b>
                        </h3>
                        <ul>
                          <li>1. Socket.oi for realtime message with notification</li>
                          <li>2. Zustand for state management</li>
                          <li>3. Password encription with bcryptjs.</li>
                        </ul>
                      </div>

                      <div className="py-2">
                        <h3 className="text-lg">
                          <b>Technology :</b>
                        </h3>
                        <p>
                          React | bcryptjs | Express | Mongoose | Socket.io | JWT | Zustand
                        </p>
                      </div>

                      <div className="flex gap-10 justify-center items-center text-center">
                        <div className="text-center">
                          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                            <a
                              href="https://real-time-chat-app-i3cm.onrender.com"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <FaGlobe />
                            </a>
                          </span>
                          <p>Live Website</p>
                        </div>
                        <div className="text-center">
                          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                            <a
                              href="https://github.com/Its-Shojib/Real-Time-Chat-App-Server-MERN"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <BsGithub />
                            </a>
                          </span>
                          <p>GitHub Code</p>
                        </div>

                        {/* <div className="text-center">
                          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                            <a
                              href="https://github.com/Its-Shojib/Milon-Mela-Matrimony-ServerSide-NodeAndMongoDB"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <BsGithub />
                            </a>
                          </span>
                          <p>Server Code</p>
                        </div> */}

                      </div>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
        {/* Project-six */}
        <div
          className="w-full p-4 h-auto rounded-lg shadow-shadowOne flex flex-col bg-gradient-to-r from-bodyColor to-[#202327] group hover:bg-gradient-to-b hover:from-gray-900 hover:gray-900 transition-colors duration-1000"
          data-aos="zoom-in-right"
        >
          <div class="relative max-w-full h-72 overflow-hidden">
            <div class="h-max w-full transition-transform duration-[5000ms] ease-linear transform translate-y-0 hover:-translate-y-[calc(100%-18rem)]">
              <img
                src={four}
                alt="project-six"
                class="w-full object-cover object-top "
              />
            </div>
          </div>

          <div className="w-full mt-5 flex flex-col  gap-6">
            <div>
              <div className="">
                <h2 className="text-designColor font-normal text-base text-center mb-1">
                  <span className="text-white uppercase text-2xl">Task Master</span>
                </h2>

                <Accordion
                  expanded={expanded === "panel6"}
                  onChange={handleChange("panel6")}
                >
                  <AccordionSummary
                    expandIcon={
                      <FaAngleDown className="text-gray-100 text-2xl" />
                    }
                    aria-controls="panel6bh-content"
                    id="panel6bh-header"
                    style={{
                      background: "rgb(33 36 40)",
                      color: "rgb(243 244 246)",
                    }}
                  >
                    <Typography>
                      <h2 className="text-xl">
                        <b>Project Details :</b>
                      </h2>
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails className="bg-bodyColor text-gray-100">
                    <Typography>
                      <div>
                        <h3 className="text-lg">
                          <b>Description :</b>
                        </h3>
                        <p className="text-sm mb-3 ">
                        Task Master is a user-friendly web app designed for efficient task management. It allows users to create tasks and organize them effortlessly using drag-and-drop functionality to move tasks between To-Do, Ongoing, and Completed categories. It's perfect for staying organized and boosting productivity.
                        </p>
                      </div>

                      <div>
                        <h3 className="text-lg">
                          <b>Features :</b>
                        </h3>
                        <ul>
                          <li>1. Drag and Drop to manage tasks</li>
                          <li>2. Authentication and Authorization</li>
                          <li>3. Priority to manage task.</li>
                        </ul>
                      </div>

                      <div className="py-2">
                        <h3 className="text-lg">
                          <b>Technology :</b>
                        </h3>
                        <p>
                          React | Node | Express | MongoDB | Tailwind | JWT | Firebase
                        </p>
                      </div>

                      <div className="flex gap-10 justify-center items-center text-center">
                        <div className="text-center">
                          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                            <a
                              href="https://task-master-web.netlify.app"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <FaGlobe />
                            </a>
                          </span>
                          <p>Live Website</p>
                        </div>
                        <div className="text-center">
                          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                            <a
                              href="https://github.com/Its-Shojib/Task-Management-Client"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <BsGithub />
                            </a>
                          </span>
                          <p>Client Code</p>
                        </div>

                        <div className="text-center">
                          <span className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300 cursor-pointer">
                            <a
                              href="https://github.com/Its-Shojib/Task-Management-Server"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <BsGithub />
                            </a>
                          </span>
                          <p>Server Code</p>
                        </div>

                      </div>
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
        
        
      </div>
    </section>
  );
};

export default Projects;
